import useEditUser from './useEditUser';

export default useEditUser;
